import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LgvGridManager } from './grid-manager';

@Component({
    selector: 'lgv-grid-pager',
    template: `
    <mat-paginator
            [pageIndex]="GridMgr.Page -1"
            [length]="GridMgr.TotalResults"
            (page)="GridMgr.OnChangeTable(GridMgr.config, $event)"
            [pageSize]="GridMgr.ItemsPerPage"
            [hidePageSize]=true
            >
    </mat-paginator>
  `,
})

// https://material.angular.io/components/paginator
// [pageSizeOptions]="[ 10, 25, 100]"

export class LgvGridPagerComponent implements OnInit {

    //Mgr: GridMgr;
    @Input() GridMgr: LgvGridManager;

    constructor() {
    }

    ngOnInit() {
    }
}
